import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const featuredServices = [
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ),
      title: "Residential Landscaping",
      description: "Complete landscape design and installation for your dream outdoor space."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
        </svg>
      ),
      title: "Garden Center Products",
      description: "Premium trees, shrubs, annuals, perennials, and bulk materials."
    },
    {
      icon: (
        <svg className="service-icon" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ),
      title: "Hardscaping",
      description: "Beautiful patios, walkways, retaining walls, and outdoor living spaces."
    }
  ];

  return (
    <div className="HomePage">
      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-content">
          <h1>Central Virginia's Premier Garden Center & Landscaping</h1>
          <p>
            For over 110 years, Snow's Garden Center has been the trusted choice for 
            exceptional landscaping, garden products, and outdoor living solutions. 
            Fourth-generation family tradition meets modern expertise.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/contact" className="btn btn-primary">
              Schedule Consultation
            </Link>
            <Link to="/services" className="btn btn-secondary">
              Our Services
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Services Section */}
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxxl)' }}>
            <h2>Featured Services</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', maxWidth: '600px', margin: '0 auto' }}>
              Discover our most popular landscaping and garden center offerings, designed to transform 
              your outdoor spaces into beautiful, functional environments.
            </p>
          </div>
          
          <div className="grid grid-cols-3">
            {featuredServices.map((service, index) => (
              <div key={index} className="card service-card">
                {service.icon}
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            ))}
          </div>
          
          <div style={{ textAlign: 'center', marginTop: 'var(--space-xxxl)' }}>
            <Link to="/services" className="btn btn-primary">
              View All Services
            </Link>
          </div>
        </div>
      </section>

      {/* Quick Info Section */}
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div className="grid grid-cols-2" style={{ alignItems: 'center', gap: 'var(--space-xxxl)' }}>
            <div>
              <h2>A Fourth-Generation Legacy</h2>
              <p style={{ fontSize: 'var(--text-lg)', marginBottom: 'var(--space-md)' }}>
                Established in spring 1912 by Leroy H. Snow and his wife Maggie, Snow's Garden Center 
                has been Central Virginia's trusted partner in creating beautiful outdoor spaces for over 110 years.
              </p>
              <p style={{ marginBottom: 'var(--space-lg)' }}>
                Our team combines decades of experience with modern techniques to help you maximize 
                your enjoyment of outdoor living spaces across Charlottesville and surrounding areas.
              </p>
              <div style={{ display: 'flex', gap: 'var(--space-md)', flexWrap: 'wrap' }}>
                <Link to="/about" className="btn btn-primary">
                  Learn More About Us
                </Link>
                <Link to="/portfolio" className="btn btn-secondary">
                  View Our Work
                </Link>
              </div>
            </div>
            
            <div className="card" style={{ 
              background: 'linear-gradient(135deg, var(--primary-100), var(--background-surface))',
              textAlign: 'center'
            }}>
              <h3 style={{ color: 'var(--primary-700)', marginBottom: 'var(--space-md)' }}>
                Why Choose Snow's?
              </h3>
              <ul style={{ 
                listStyle: 'none', 
                padding: 0,
                textAlign: 'left'
              }}>
                <li style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 'var(--space-sm)',
                  color: 'var(--neutral-900)'
                }}>
                  <svg style={{ 
                    width: '20px', 
                    height: '20px', 
                    color: 'var(--success)',
                    marginRight: 'var(--space-xs)'
                  }} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                  </svg>
                  Fourth-generation family business since 1912
                </li>
                <li style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 'var(--space-sm)',
                  color: 'var(--neutral-900)'
                }}>
                  <svg style={{ 
                    width: '20px', 
                    height: '20px', 
                    color: 'var(--success)',
                    marginRight: 'var(--space-xs)'
                  }} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                  </svg>
                  Over 110 years of proven experience
                </li>
                <li style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 'var(--space-sm)',
                  color: 'var(--neutral-900)'
                }}>
                  <svg style={{ 
                    width: '20px', 
                    height: '20px', 
                    color: 'var(--success)',
                    marginRight: 'var(--space-xs)'
                  }} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                  </svg>
                  Comprehensive landscaping & garden center
                </li>
                <li style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  color: 'var(--neutral-900)'
                }}>
                  <svg style={{ 
                    width: '20px', 
                    height: '20px', 
                    color: 'var(--success)',
                    marginRight: 'var(--space-xs)'
                  }} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                  </svg>
                  Serving all of Central Virginia
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="section">
        <div className="container">
          <div className="card" style={{ 
            textAlign: 'center',
            background: 'var(--primary-100)',
            border: '2px solid var(--primary-500)'
          }}>
            <h2 style={{ color: 'var(--primary-700)', marginBottom: 'var(--space-md)' }}>
              Ready to Transform Your Outdoor Space?
            </h2>
            <p style={{ fontSize: 'var(--text-lg)', marginBottom: 'var(--space-lg)', maxWidth: '600px', margin: '0 auto var(--space-lg)' }}>
              Contact us today for a free consultation and let's discuss how we can bring your 
              outdoor vision to life with our professional landscaping services.
            </p>
            <div style={{ display: 'flex', gap: 'var(--space-md)', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn btn-primary">
                Schedule Free Consultation
              </Link>
              <a href="tel:434-295-2159" className="btn btn-secondary">
                Call (434) 295-2159
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;